import app from "flarum/forum/app";

// Render the original GIF unchanged: all 84 frames retain their 40ms timing.
// The SVG filter recolors the artwork, removes its background, and thickens it.
export default function sessionLoaderSvg() {
  // The boot loader can render before Flarum has initialized app.forum.
  const bundle = Array.from(document.scripts).find(script => /\/forum\.js(?:\?|$)/.test(script.src));
  const assetsBase = app.forum?.attribute("assetsBaseUrl") || (bundle ? new URL(".", bundle.src).href : new URL("assets/", document.baseURI).href);
  const url = `${assetsBase.replace(/\/$/, "")}/extensions/htwsaar-htw-theme/session-loader.gif`;
  const href = url.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
  const palette = ["#cd1f24", "#cd1f24", "#cd1f24", "#bc6c25", "#5f6c37", "#5f6c37", "#b6bb17", "#b6bb17", "#dde27f", "#dde27f"];
  const channel = (offset) => palette.map(color => parseInt(color.slice(offset, offset + 2), 16) / 255).join(" ");

  return `<svg viewBox="144 144 512 512" class="CirklaInitialSessionLoader-spinnerSvg" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="cirkla-session-loader-colors" color-interpolation-filters="sRGB" x="0" y="0" width="100%" height="100%">
        <feColorMatrix type="matrix" values="0.2126 0.7152 0.0722 0 0  0.2126 0.7152 0.0722 0 0  0.2126 0.7152 0.0722 0 0  0.2126 0.7152 0.0722 0 0" />
        <feComponentTransfer result="brandColors">
          <feFuncR type="discrete" tableValues="${channel(1)}" />
          <feFuncG type="discrete" tableValues="${channel(3)}" />
          <feFuncB type="discrete" tableValues="${channel(5)}" />
          <feFuncA type="linear" slope="-8" intercept="7.4" />
        </feComponentTransfer>
        <feColorMatrix in="brandColors" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0" result="inkAlpha" />
        <feMorphology in="inkAlpha" operator="dilate" radius="6" result="thickerAlpha" />
        <feFlood flood-color="#5f6c37" result="outlineColor" />
        <feComposite in="outlineColor" in2="thickerAlpha" operator="in" result="outline" />
        <feMerge><feMergeNode in="outline" /><feMergeNode in="brandColors" /></feMerge>
        <feGaussianBlur stdDeviation="0.6" />
      </filter>
    </defs>
    <image href="${href}" x="0" y="0" width="800" height="800" filter="url(#cirkla-session-loader-colors)" />
  </svg>`;
}

let pendingInitialRequests = false;
let readinessTimer = null;
const SHOW_DELAY_MS = 150;

export function setSessionLoaderPending(isPending) {
  pendingInitialRequests = isPending;
}

function sessionContentReady() {
  return !!app.forum && !!app.session && !pendingInitialRequests;
}

// Fast loads never reveal the overlay. Slow loads keep the original animation
// until session data and foreground requests are ready, with no minimum duration.
export function startSessionLoader(loader) {
  loader.style.setProperty("display", "none", "important");
  window.setTimeout(() => {
    if (!loader.isConnected) return;
    if (sessionContentReady()) {
      finishSessionLoader();
    } else {
      loader.style.removeProperty("display");
    }
  }, SHOW_DELAY_MS);
}

export function finishSessionLoader() {
  window.clearTimeout(readinessTimer);
  const loaders = Array.from(document.querySelectorAll(".CirklaInitialSessionLoader"));
  if (loaders.length && !sessionContentReady()) {
    readinessTimer = window.setTimeout(finishSessionLoader, 50);
    return;
  }
  loaders.forEach(loader => loader.remove());
  document.body.classList.remove("CirklaSessionBooting");
  readinessTimer = null;
}
